export class ReportFilters {
    optionalFields: number[];
    cycleId: number;
    reportId: number;
    directSubordinates:boolean = false;
    userStatus: number = null;
    attributeIds: number[] = null;
    cycleProcessConfigId?: number;
    usersToGetReport?: string[];
    language: string = "en-US";
    constructor(optionalFields: number[], cycleId: number, reportId: number, directSubordinates: boolean, userStatus: number, attributeIds: number[], cycleProcessConfigId: number, usersToGetReport: string[], language: string) {
        this.optionalFields = optionalFields;
        this.cycleId = cycleId;
        this.reportId = reportId;
        this.directSubordinates = Boolean(directSubordinates);
        this.userStatus = userStatus || null;
        this.attributeIds = attributeIds || null;
        this.cycleProcessConfigId = cycleProcessConfigId;
        this.usersToGetReport = usersToGetReport;
        this.language = language || "en-US";
    }
}